export class XilicaSolaro {
    constructor(socket, log) {
        this.socket = socket;
        this.channels = {};
        this.asyncHandlers = [
            {
                name: 'paramGet',
                regExp: /GET (.+)/i,
                callback: (match) => {
                    if (this.channels.hasOwnProperty(match[1])) {
                        const chan = this.channels[match[1]];
                        if (chan.mute !== undefined) {
                            this.socket.send(`${match[1]}=${chan.mute ? 'TRUE' : 'FALSE'}`);
                        }
                        else if (chan.gain !== undefined) {
                            this.socket.send(`${match[1]}=${chan.gain}`);
                        }
                        else {
                            this.socket.send(`ERROR=104`);
                        }
                    }
                    else {
                        this.socket.send(`ERROR=104`);
                    }
                },
            },
            {
                name: 'muteSet',
                regExp: /^SET\s+(.+)\s+(TRUE|FALSE)/i,
                callback: (match) => {
                    this.channels[match[1]].mute = match[2] === 'TRUE';
                    this.socket.send(`OK`);
                },
            },
            {
                name: 'keepalive',
                regExp: /KEEPALIVE/i,
                callback: (match) => { },
            },
            {
                name: 'volumeSet',
                regExp: /^SET\s+(.+)\s+([-+]?[\d\.]+)/i,
                callback: (match) => {
                    this.channels[match[1]].gain = parseFloat(match[2]);
                    this.socket.send(`OK`);
                },
            },
            {
                name: 'refresh',
                regExp: /REFRESH/i,
                callback: (match) => {
                    for (const [key] of Object.entries(this.channels)) {
                        let value = undefined;
                        if (this.channels[key].mute !== undefined) {
                            value = this.channels[key].mute ? 'TRUE' : 'FALSE';
                            this.socket.send(`#${key}=${value}`);
                        }
                        else if (this.channels[key].gain !== undefined) {
                            value = this.channels[key].gain;
                            this.socket.send(`#${key}=${value}`);
                        }
                        else {
                            this.socket.send(`ERROR=104`);
                        }
                    }
                },
            },
            {
                name: 'interval',
                regExp: /INTERVAL \d+/i,
                callback: (match) => {
                    this.socket.send(`OK`);
                },
            },
            {
                name: 'presetRecall',
                regExp: /^PRESET (?:"(.+)"|(.+))/i,
                callback: (match) => {
                    this.socket.send(`OK`);
                    const name = match[1];
                    if (name === 'Mics Mute') {
                        this.channels.Mics.mute = true;
                        this.socket.send(`#Mics=TRUE`);
                    }
                    else if (name === 'Mics Unmute') {
                        this.channels.Mics.mute = false;
                        this.socket.send(`#Mics=FALSE`);
                    }
                },
            },
            {
                name: 'subscribe',
                regExp: /^SUBSCRIBE (.+)/i,
                callback: (match) => {
                    let value = undefined;
                    const key = match[1];
                    if (this.channels[key].mute !== undefined) {
                        value = this.channels[key].mute ? 'TRUE' : 'FALSE';
                        this.socket.send(`#${key}=${value}`);
                        this.socket.send(`OK`);
                    }
                    else if (this.channels[key].gain !== undefined) {
                        value = this.channels[key].gain;
                        this.socket.send(`#${key}=${value}`);
                        this.socket.send(`OK`);
                    }
                    else {
                        this.socket.send(`ERROR=104`);
                    }
                },
            },
            {
                name: 'unsubscribe',
                regExp: /^UNSUBSCRIBE (.+)/i,
                callback: (match) => {
                    const key = match[1];
                    if (this.channels[key].mute !== undefined ||
                        this.channels[key].gain !== undefined) {
                        this.socket.send(`OK`);
                    }
                    else {
                        this.socket.send(`ERROR=107`);
                    }
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`ERROR=101`);
                },
            },
        ];
        this.channels['Mics'] = { mute: false };
        this.channels['Amplifier'] = { gain: 0.0 };
        this.channels['WirelessMicGain'] = { gain: 0.0 };
        this.channels['WirelessMicMute'] = { mute: false };
        for (let i = 1; i <= 8; i++) {
            this.channels[`Input_${i}_Mute`] = { mute: false };
            this.channels[`Input_${i}_Gain`] = { gain: 0.0 };
            this.channels[`Output_${i}_Mute`] = { mute: false };
            this.channels[`Output_${i}_Gain`] = { gain: 0.0 };
        }
    }
}
XilicaSolaro.emulatorType = 'socketEmulator';
XilicaSolaro.key = '-N-99Y3kNMVrsQk2RxV7';
